import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { onError } from 'apollo-link-error';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { createHttpLink } from 'apollo-link-http';
import { authenticatedFetch } from './authenticatedFetch';
import renewAccessToken from './renewAccessToken';
import { isHostRdr } from './urls';

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const httpLink = createHttpLink({
  uri: isHostRdr() ? '/fc/graphql' : '/graphql',
  fetch: authenticatedFetch,
});

const batchLink = new BatchHttpLink({
  uri: isHostRdr() ? '/fc/graphql' : '/graphql',
  fetch: authenticatedFetch,
});

const errorLink = onError(({ networkError }) => {
  if (networkError) {
    if (networkError.statusCode === 401) {
      renewAccessToken();
    }
  }
});

const cache = new InMemoryCache({
  addTypename: false,
});

export const apolloClient = new ApolloClient({
  cache,
  link: errorLink.concat(httpLink),
  defaultOptions,
});

export const apolloBatchClient = new ApolloClient({
  cache,
  link: errorLink.concat(batchLink),
  defaultOptions,
});
